import { useSignupState } from '../hooks'

export const useSkipPrintersFetch = () => {
  const signupState = useSignupState()
  const isManageAccountEnabled = signupState.settings?.data?.enableManageAccount
  const userCreatedAt = signupState.activeUser?.data?.createdAt

  let isNewlyCreatedAccount = false
  if (userCreatedAt) {
    const createdAtDate = new Date(userCreatedAt)
    const tenMinutesAgo = new Date(Date.now() - 10 * 60 * 1000)
    isNewlyCreatedAccount = createdAtDate > tenMinutesAgo
  }

  const shouldSkipFetchPrinters =
    isManageAccountEnabled && isNewlyCreatedAccount

  return {
    shouldSkipFetchPrinters
  }
}
